<template>
  <div class="rate-wrapper">
    <!-- 滑块题->利克特量表 -->
    <answer-option-list
      v-if="config.scoreQuType === '1'"
      :config="config"
      :prop="prop"
      :model="model"
      :answerValidate="answerValidate"
      optionKey="optionTitle"
      optionValueKey="optionName"
      @selIndexChange="selIndexChange"
    ></answer-option-list>
    <!-- 滑块题->星形->去掉，用满意度的星形 -->
    <div
      v-else-if="config.scoreQuType === '2'"
      class="rate rate-2"
    >
      <FormItem :prop="prop" :rules="myRules">
        <div class="slide-star">
          <van-rate
            v-model="model.value"
            void-icon="star"
            :id="`rate-${model.id}`"
            :count="parseInt(config.paramInt02)"
            @change="rateChange(model)"
          />
        </div>
      </FormItem>
    </div>
    <!-- 滑块题-双极量表 -->
    <div
      v-else-if="config.scoreQuType === '3'"
      class="rate rate-3"
      :class="[{'is-matrix': config.descList.length > 0}]"
    >
      <FormItem :prop="prop" :rules="myRules">
        <div class="slider">
          <div class="slider-wrap">
            <div class="main">
              <vue-slider
                @drag-start="dragStart('slider3')"
                @drag-end="onSliderDown('slider3')"
                @callback="onCb(3)"
                @mousedown.native="onSliderDown('slider3', 'click')"
                class="slider3 udf-slider"
                :class="[!model.value ? 'no-choose' : '']"
                ref="slider3"
                v-model="model.tmpValue"
                :sliderStyle="quTypeCommonStyle.sliderStyle"
                :bgStyle="quTypeCommonStyle.bgStyle"
                :processStyle="quTypeCommonStyle.processStyle"
                :min="parseInt(min)"
                :max="parseInt(config.paramInt02)"
                :clickable="true"
                :tooltip="model.value > 0 ? 'always' : 'false'"
                piecewise
              >
                <template slot="label" slot-scope="{ label, index, active, first, last }">
                  <span></span>
                </template>
              </vue-slider>
            </div>
            <!-- 非矩阵题显示 -->
            <div v-if="!config.descList.length" class="bottom">
              <div class="item left-item">
                <span class="arrow"></span>
                {{config.optionList[0].displayTitle}}
              </div>
              <div class="item center-item">
                {{config.optionList[1].displayTitle}}
              </div>
              <div class="item right-item">
                <span class="arrow"></span>
                {{config.optionList[2].displayTitle}}
              </div>
            </div>
          </div>
        </div>
      </FormItem>
    </div>
    <!-- 滑块题->滑块 -->
    <div 
      v-else-if="config.scoreQuType === '4'"
      class="rate rate-4"
      :class="[{'is-matrix': config.descList.length > 0}]"
    >
      <FormItem :prop="prop" :rules="myRules">
        <div class="slider">
          <div class="slider-wrap slider-bt-wrap slider-4-wrap" :class="[{'slider-4-100-wrap': config.paramInt02 === '100', 'slider-init': config.scoreQuInitial > 1}]">
            <div class="main">
              <vue-slider
                @drag-start="dragStart('slider4')"
                @drag-end="onSliderDown('slider4')"
                @callback="onCb(4)"
                @mousedown.native="onSliderDown('slider4', 'click')"
                :class="[!model.value ? 'no-choose' : '']"
                ref="slider4"
                v-model="model.tmpValue"
                :sliderStyle="quTypeCommonStyle.sliderStyle"
                :bgStyle="quTypeCommonStyle.bgStyle"
                :processStyle="quTypeCommonStyle.processStyle"
                :min="parseInt(min)"
                :max="parseInt(config.paramInt02)"
                :clickable="true"
                :piecewiseFilter="slider4PieceWiseFilter"
                :tooltip="model.value > 0 ? 'always' : 'false'"
                piecewise
              >
                <template slot="label" slot-scope="{ label, index, active, first, last }">
                  <span>
                  </span>
                </template>
              </vue-slider>
            </div>
            <!-- 非矩阵题显示 -->
            <div v-if="!config.descList.length" class="bottom">
              <div class="item left-item">
                <span class="arrow"></span>
                {{config.optionList[0].displayTitle}}
              </div>
              <div class="item right-item">
                <span class="arrow"></span>
                {{config.optionList[1].displayTitle}}
              </div>
            </div>
          </div>
        </div>
      </FormItem>
    </div>
    <!-- 滑块题->正好尺度 -->
    <FormItem
      v-else-if="config.scoreQuType === '5'"
      :prop="prop"
      :rules="myRules"
    >
      <div class="rate rate5">
        <div class="slider">
          <div class="line"></div>
          <div class="dots">
            <div
              class="dot animated"
              :class="['dot' + (5 - index), model.value ===  5 - index ? 'selected fadeIn' : '']"
              v-for="(option, index) in config.optionList"
              :key="index + 'dot'"
              @click="selectSlider5(index)"
            ></div>
          </div>
        </div>
        <div class="rate5-options">
          <div
            class="rate5-option"
            :class="[model.value ===  5 - index ? 'selected' : '']"
            v-for="(option, index) in config.optionList"
            :key="option.id"
            @click="selectSlider5(index)"
          >
            <answer-lang :langObj="option" :text="option.optionTitle"></answer-lang>
          </div>
        </div>
      </div>
    </FormItem>
    <!-- NPS题 -->
    <div
      v-else-if="config.scoreQuType === '6'"
      class="rate rate-6"
      :class="[{'is-matrix': config.descList.length > 0}]"
    >
      <FormItem :prop="prop" :rules="myRules">
        <div class="slider">
          <div class="slider-wrap slider-bt-wrap slider-4-wrap">
            <div class="main">
              <vue-slider
                @drag-start="dragStart('slider6')"
                @drag-end="onSliderDown('slider6')"
                @callback="onCb(6)"
                @mousedown.native="onSliderDown('slider6', 'click')"
                :class="[!model.value ? 'no-choose' : '']"
                ref="slider6"
                v-model="model.tmpValue"
                :sliderStyle="quType6Style.sliderStyle"
                :bgStyle="quType6Style.bgStyle"
                :processStyle="quType6Style.processStyle"
                :min="parseInt(config.paramInt01)"
                :max="parseInt(config.paramInt02)"
                :clickable="true"
                :tooltip="(model.value || model.value === 0) ? 'always' : 'false'"
                piecewise
              >
                <template slot="label" slot-scope="{ label, index, active, first, last }">
                  <span></span>
                </template>
              </vue-slider>
            </div>
            <!-- 非矩阵题显示 -->
            <div v-if="!config.descList.length" class="bottom">
              <div class="item left-item">
                <span class="arrow"></span>
                {{config.optionList[0].displayTitle}}
              </div>
              <div class="item right-item">
                <span class="arrow"></span>
                {{config.optionList[1].displayTitle}}
              </div>
            </div>
            <!-- <div class="bottom">
              <answer-lang
                    :langObj="config.optionList[0]"
                    :text="config.optionList[0].optionTitle"
                  ></answer-lang>
                  <answer-lang
                    :langObj="config.optionList[1]"
                    :text="config.optionList[1].optionTitle"
                  ></answer-lang>
            </div> -->
          </div>
        </div>
      </FormItem>
    </div>

    <!-- 不清楚/不知道 -->
    <div v-if="hasUnknownOption && !['1', '6'].includes(config.scoreQuType)" :class="`unknown-box ${device === 'mobile' ? 'unknown-box-mobile' : ''}`">
      <el-radio v-model="unknownVal" @input="unknownChange" :label="1">
        <span class="txt">{{ config.optionList[config.optionList.length - 1].optionTitle }}</span>
      </el-radio>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import { mapGetters, mapState } from 'vuex'
import {addClass, removeClass} from '@/utils/dom'
export default {
  name: 'RateGroupAnswer',
  props: ['config', 'model', 'prop', 'crtDescIndex', 'rules', 'cvtLang', 'answerValidate'],
  data () {
    return {
      quTypeCommonStyle: {
        sliderStyle: {
          boxShadow: 'none',
          borderStyle: 'solid',
          borderWidth: '2px',
          borderColor: '#4CBAA2',
          width: '18px',
          height: '18px',
          marginTop: '-1px',
          marginLeft: '-1px'
        },
        bgStyle: {
          background: '#eee',
          borderRadius: '8px'
        },
        processStyle: {
          background: '#4CBAA2'
        }
      },
      quType6Style: {
        sliderStyle: {
          boxShadow: 'none',
          borderStyle: 'solid',
          borderWidth: '2px',
          borderColor: '#F5222D',
          width: '18px',
          height: '18px',
          marginTop: '-1px',
          marginLeft: '-1px'
        },
        bgStyle: {
          // height: '12px',
          // background: 'linear-gradient(90deg, #ff8096 0%, #e01f07 100%)',
          // background: 'linear-gradient(90deg, #FF6868 0%, #FFE58A 51%, #45BAA3 100%)',
          background: '#eee',
          borderRadius: '8px'
        },
        processStyle: {
          // background: 'transparent'
          background: '#F5222D'
        }
      },
      unknownVal: 0,
      stashValue: 0,
      eventType: 'dragEnd',
      // 默认表单验证规则
      myRules: [
        {
          validator: (rule, value, callback) => {
            let valIndex
            if (this.config.elementType === 'RateGroupBox') {
              valIndex = Number(rule.field.split('.')[1])
            }
            const errors = this.answerValidate.validate.bind(this.config)(this, true, valIndex).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {
    VueSlider
  },
  watch: {
    crtDescIndex (newVal) {
      const scoreQuType = this.config.scoreQuType
      if (scoreQuType === '3' || scoreQuType === '4' || scoreQuType === '5') {
        const $slider = this.$refs[`slider${scoreQuType}`]
        this.$nextTick(() => {
          $slider && $slider.refresh()
        })
      }
    },
    'config.invalidConfig.geLe' (newVal) {
      // 滑块题监听
      if (newVal) {
        // reset value
        this.model.tmpValue = this.config.scoreQuType === '6' ? 0 : 1
        
        if (this.config.scoreQuType === '2') {
          this.model.value = 0
          this.unknownVal = 0
          this.rateChange(this.config)
        } else {
          this.model.value = ''
          this.unknownVal = 0
        }
      }
    },
    'model.invalidConfig.geLe' (newVal) {
      // 矩阵滑块题监听
      if (newVal) {
        // reset value
        this.model.tmpValue = this.config.scoreQuType === '6' ? 0 : 1

        if (this.config.scoreQuType === '2') {
          this.model.value = 0
          this.unknownVal = 0
          this.rateChange(this.model)
        } else {
          this.model.value = ''
          this.unknownVal = 0
        }
      } else {
        if (this.config.scoreQuType === '2') {
          // 移除rate-disabled
          const rateEl = document.getElementById('rate-'+this.model.id)
          if (rateEl) {
            for(let i=0; i<rateEl.children.length; i++) {
              removeClass(rateEl.children[i], 'rate-disabled')
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device,
      answerStyleConfig: ({Question}) => Question.answerStyleConfig,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang,
      hasUnknownOption() {
        let flag = false
        if (this.config.optionList.find(item => item.optionName === '-999')) {
          flag = true
        }
        return flag
      }
    }),
    scale () {
      if (this.config.paramInt02 === '100') {
        return 100
      }
      return 1
    },
    min () {
      if (this.config.scoreQuInitial && this.config.paramInt02 === '100') {
        return this.config.scoreQuInitial
      }
      return 1
    },
    max () {
      return parseInt(this.config.paramInt02)
    }
  },
  methods: {
    slider4PieceWiseFilter ({index, label}) {
      return this.config.paramInt02 === '10' ? true : label % 10 === 0
    },
    onCb (type) {
      // 为了提交的时候答案选项有值
      // this.model.value = this.model.tmpValue + ''
      // TODO: 初次赋值时要加到异步队列里走logic exec
      setTimeout(() => {
        sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
        this.model.value = this.model.tmpValue + ''
        if (this.model.value > 0) {
          this.unknownVal = 0
        }
        if (type === 6) {
          // NPS题
          this.quType6Style.processStyle.background = this.getBackground(this.model.value)
          this.quType6Style.sliderStyle.borderColor = this.getBackground(this.model.value)
        }
        if (this.config.descList.length) {
          // 矩阵题
          sessionStorage.setItem('descPropValid', this.prop)
        }
        // TODO: click时校验无效
        if (this.eventType === 'dragEnd') {
          if (this.config.invalidConfig) {
            // 滑块题->有无效选项验证
            setTimeout(() => {
              this.settingSliderRange(this.config)
            }, 0)
          } else if (this.model.invalidConfig) {
            // 矩阵滑块题->有无效选项验证
            setTimeout(() => {
              this.settingSliderRange(this.model)
            }, 0)
          }
        }
      }, 10)
    },
    dragStart() {
      this.eventType = 'drag'
    },
    getBackground(val) {
      const v = Number(val)
      let bg = ''
      if (v >= 0 && v <= 6) {
        bg = '#F5222D'
      } else if (v > 6 && v < 9) {
        bg = '#FFC53D'
      } else {
        bg = '#4CBAA2'
      }
      return bg
    },
    // 题型5和其他题型值的类型不一样，所以做单独处理
    onCb5 () {
      this.model.value = this.model.tmpValue
    },
    onSliderDown (slider, type) {
      if (!type) {
        this.eventType = 'dragEnd'
      }
      if (this.config.invalidConfig) {
        // 滑块题->有无效选项验证
        setTimeout(() => {
          this.settingSliderRange(this.config)
        }, 0)
      } else if (this.model.invalidConfig) {
        // 矩阵滑块题->有无效选项验证
        setTimeout(() => {
          this.settingSliderRange(this.model)
        }, 0)
      }

      if (!this.model.value) {
        this.model.value = this.config.paramInt01 + ''
      }
      this.$refs[slider].refresh && this.$refs[slider].refresh()
    },
    // 设置滑动范围
    settingSliderRange(config) {
      const {paramInt01, paramInt02, scoreQuType} = this.config
      const {geLe, maxValue, minValue, toQuItemId} = config.invalidConfig
      const rangeArr = []
      let disabledArr = []
      let enabledArr = []
      let nextIndex = 0
      for (let i=Number(paramInt01); i<=Number(paramInt02); i++) {
        rangeArr.push(i)
      }

      if (geLe === '1') {
        // 等于
        disabledArr = toQuItemId.split(',').map(item => (Number(item)))
      } else if (geLe === '2') {
        // 介于，包含两端
        for (let i=Number(minValue); i<=Number(maxValue); i++) {
          disabledArr.push(i)
        }
      } else if (geLe === '3') {
        // 小于
        for (let i=0; i<Number(toQuItemId); i++) {
          disabledArr.push(i)
        }
      } else if (geLe === '4') {
        // 小于等于
        for (let i=0; i<=Number(toQuItemId); i++) {
          disabledArr.push(i)
        }
      } else if (geLe === '5') {
        // 大于
        for (let i=Number(toQuItemId) + 1; i<=rangeArr.length; i++) {
          disabledArr.push(i)
        }
      } else if (geLe === '6') {
        // 大于等于
        for (let i=Number(toQuItemId); i<=rangeArr.length; i++) {
          disabledArr.push(i)
        }
      }
      enabledArr = rangeArr.filter((item)=>{return disabledArr.indexOf(item) < 0})
      
      if (scoreQuType === '2') {
        // 星形题
        if (enabledArr.length) {
          if (enabledArr.indexOf(this.model.value) > -1) {
            nextIndex = enabledArr.indexOf(this.model.value)
          } else if (enabledArr.indexOf(this.model.value) < 0) {
            nextIndex = this.findNearbyIndex(enabledArr, this.model.value)
          }
          this.model.value = enabledArr[nextIndex]
        }
      } else {
        // 非星形题

        // console.log('tmpValue', this.model.tmpValue)
        if (enabledArr.length) {
          if (enabledArr.indexOf(this.model.tmpValue) > -1) {
            nextIndex = enabledArr.indexOf(this.model.tmpValue)
          } else if (enabledArr.indexOf(this.model.tmpValue) < 0) {
            nextIndex = this.findNearbyIndex(enabledArr, this.model.tmpValue)
          }
        }
        // console.log('enabledArr', enabledArr)
        // console.log('nextIndex', nextIndex)

        if (nextIndex === 0) {
          // 初始0值
          setTimeout(() => {
            this.model.tmpValue = enabledArr[nextIndex]
            this.model.value = this.model.tmpValue + ''
          }, 0)
        } else {
          this.model.tmpValue = enabledArr[nextIndex]
          this.model.value = this.model.tmpValue + ''
        }
      }


    },
    // 获取相近的元素索引
    findNearbyIndex(list, value) {
      if (!list.find(item => {return item === value})) {
        if (value < Math.max(...list)) {
          return this.findNearbyIndex(list, value+1)
        } else {
          return this.findNearbyIndex(list, value-1)
        }
      } else {
        return list.indexOf(value)
      }
    },
    selectSlider5 (index) {
      this.model.tmpValue = 5 - index
      this.onCb5()
    },
    tap (e) {
      console.log('tap')
    },
    panstart (e) {
      console.log(e)
      console.log('start')
    },
    panmove (e) {
      const touch = e.touches[0]
      console.log(touch.pageX)
      console.log('mv')
    },
    panend (e) {
      console.log('ed')
    },
    unknownChange() {
      if (this.config.descList.length) {
        // 矩阵题
        this.model.value = Number(this.config.optionList[this.config.optionList.length - 1].optionName)
        this.model.tmpValue = 1
      } else {
        // 非矩阵题
        this.config.value = Number(this.config.optionList[this.config.optionList.length - 1].optionName)
        this.model.tmpValue = 1
      }

      // reset
      this.stashValue = 0
    },
    rateChange(config) {
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
      if (config.invalidConfig) {
        const {geLe, maxValue, minValue, toQuItemId} = config.invalidConfig
        const {paramInt01, paramInt02} = this.config
        const rangeArr = []
        for (let i=Number(paramInt01); i<=Number(paramInt02); i++) {
          rangeArr.push(i)
        }
        let disabledArr = []

        if (geLe === '1') {
          // 等于
          disabledArr = toQuItemId.split(',').map(item => (Number(item)))
        } else if (geLe === '2') {
          // 介于，包含两端
          for (let i=Number(minValue); i<=Number(maxValue); i++) {
            disabledArr.push(i)
          }
        } else if (geLe === '3') {
          // 小于
          for (let i=0; i<Number(toQuItemId); i++) {
            disabledArr.push(i)
          }
        } else if (geLe === '4') {
          // 小于等于
          for (let i=0; i<=Number(toQuItemId); i++) {
            disabledArr.push(i)
          }
        } else if (geLe === '5') {
          // 大于
          for (let i=Number(toQuItemId) + 1; i<=rangeArr.length; i++) {
            disabledArr.push(i)
          }
        } else if (geLe === '6') {
          // 大于等于
          for (let i=Number(toQuItemId); i<=rangeArr.length; i++) {
            disabledArr.push(i)
          }
        }

        // 有无效选项验证
        const rateEl = document.getElementById('rate-'+config.id)
        if (rateEl) {
          disabledArr.forEach(item => {
            const currEl = rateEl.children[item - 1]
            addClass(currEl, 'rate-disabled')
          })
        }
        if (disabledArr.includes(this.model.value)) {
          this.model.value = this.stashValue
          return
        }
        this.stashValue = this.model.value
        // 不清楚/不知道选项互斥
        if (this.model.value > 0) {
          this.unknownVal = 0
        }
        
        return
      }

      if (this.config.descList.length) {
        // 矩阵题
        if (this.model.value > 0) {
          this.unknownVal = 0
        }
        sessionStorage.setItem('descPropValid', this.prop)
      } else {
        // 非矩阵题
        if (this.config.value > 0) {
          this.unknownVal = 0
        }
      }
    },
    selIndexChange(index) {
      sessionStorage.setItem('descPropValid', this.prop)
    }
  },
  created () {
  },
  mounted () {
    // 断点续答
    if (this.config.descList.length) {
      // 矩阵题
      if (this.model.value == '-999') {
        this.unknownVal = 1
      }
    } else {
      // 非矩阵题
      // 不清楚/不知道
      if (this.config.value == '-999') {
        this.unknownVal = 1
      }
    }
    if (this.config.scoreQuType === '2') {
      this.rateChange(this.model)
    }

    // reset 非矩阵（当存在无效选项时）
    if (this.config.invalidConfig) {
      this.model.tmpValue = this.config.scoreQuType === '6' ? 0 : 1
      
      if (this.config.scoreQuType === '2') {
        this.model.value = 0
        this.rateChange(this.config)
      } else {
        this.model.value = ''
      }
    }
    // reset 矩阵（当存在无效选项时）
    if (this.config.descList && this.config.descList.length) {
      this.config.descList.forEach(item => {
        if (item.invalidConfig) {
          item.tmpValue = this.config.scoreQuType === '6' ? 0 : 1
          item.value = ''
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rate-wrapper {
  // 不清楚/不知道
  .unknown-box {
    margin-top: 30px;
    margin-left: 6px;
    margin-top: 10px;
    >>> .el-radio {
      white-space: normal;
      line-height: 22px;
      word-break: break-word;
    }
    .txt {
      position: relative;
      left: -6px;
      top: 0px;
      font-weight: 400;
      color: #333;
      font-size: 28px;
    }
  }
  .unknown-box-mobile {
    >>> .el-radio {
      line-height: 48px;
      margin-right: 20px;
      display: flex;
      .el-radio__inner {
        width: 30px;
        height: 30px;
        position: relative;
        top: 8px;
        box-shadow:0 0 0 0 !important;
      }
      .el-radio__inner::after {
        width: 7px;
        height: 7px;
      }
      .el-radio__label {
        margin-left: 8px;
        line-height: 44px;
      }
    }
  }
}
.answer-pc {
  .rate-wrapper {
    .unknown-box {
      margin-top: 15px;
      margin-left: 3px;
      .txt {
        left: -3px;
        top: 1px;
        font-size: 14px;
      }
    }
  }
}
</style>
<style lang="scss">
.answer {
  .rate5 {
    display: flex;
    align-items: center;
    .slider {
      position: relative;
      width: 80px;
      margin-right: 20px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .vue-slider-vertical {
        position: absolute;
        margin: 0 !important;
        padding: 0 !important;
        left: 50%;
      }

      .line {
        position: absolute;
        height: 380px;
        left: 50%;
        top: 40px;
        width: 2px;
        background: linear-gradient(
          180deg,
          rgba(132, 132, 132, 1) 0%,
          rgba(199, 199, 199, 1) 100%
        );
      }

      .dots {
        position: relative;
        z-index: 3;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 440px;

        .dot {
          position: relative;
          background: rgba(255, 255, 255, 1);
          border-radius: 50%;
          border: 1px solid rgba(194, 194, 194, 1);
        }

        .dot.selected {
          background-color: rgba(218, 242, 255, 1);
          border: 2px solid #3cc6eb;
        }

        .dot1 {
          top: -14px;
          right: -1px;
          width: 18px;
          height: 18px;
        }

        .dot2 {
          top: -18px;
          width: 24px;
          height: 24px;
        }

        .dot3 {
          top: -20px;
          width: 30px;
          height: 30px;
        }

        .dot4 {
          top: -14px;
          width: 36px;
          height: 36px;
        }

        .dot5 {
          top: -1px;
          width: 42px;
          height: 42px;
        }
      }
    }

    .rate5-options {
      flex: 1;
      .rate5-option {
        cursor: pointer;
        position: relative;
        height: 79px;
        line-height: 79px;
        text-align: center;
        font-size: 28px;
        font-family: PingFang-SC-Medium;
        color: #000;
        font-weight: 500;
        border: 1px solid #c2c2c2;
        background: #fff;
        transition: background-color 0.5s ease-in;
        transition: border-color 0.5s ease-in;
      }

      .rate5-option:not(:last-child) {
        margin-bottom: 21px;
      }

      .rate5-option.selected {
        background-color: rgba(218, 242, 255, 1);
        border: 1px solid rgba(60, 198, 235, 1);
      }

      .rate5-option.selected::after {
        content: "";
        position: absolute;
        left: -12px;
        top: 50%;
        transform: translateY(-50%);
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-right: 12px solid #3cc6eb;
        border-bottom: 12px solid transparent;
      }

      .rate5-option.selected::before {
        content: "";
        position: absolute;
        z-index: 2;
        left: -10px;
        top: 50%;
        transform: translateY(-50%);
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-right: 12px solid #daf2ff;
        border-bottom: 12px solid transparent;
      }
    }
  }

  .ivu-form-item-error-tip {
    padding-left: 0 !important;
  }
}
// .vue-slider {
//   background: linear-gradient(90deg, #ff8096 0%, #e01f07 70%) !important;
// }


.rate-wrapper {
  margin: 20px 0 40px 0;
  .slide-star {
    margin-top: 20px;
    .van-rate {
      display: flex;
      justify-content: space-between;
      .van-rate__item {
        margin-right: 8px;
        .van-icon {
          font-size: 50px;
          color: #c8d3df;
        }
        .van-rate__icon--full {
          color: #FFC53D;
        }
      }
      .rate-disabled {
        opacity: .5;
      }
    }
  }
  .rate-3, .rate-4, .rate-6 {
    margin-top: 100px;
    .ivu-form-item-error-tip {
      position: absolute;
      top: -70px;
    }
  }
  .rate {
    &.rate-2 {
      .ivu-form-item {
        margin-bottom: 0;
      }
    }
    .slider-wrap {
      .bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding: 0 16px;
        .item {
          background: #f2f2f2;
          border-radius: 8px;
          color: rgba(0, 0, 0, 0.45);
          padding: 0 20px;
          font-size: 24px;
          line-height: 48px;
          position: relative;
          .arrow {
            width: 0px;
            height: 0px;
            border-width: 10px 10px 0px 0px;
            border-style: solid;
            border-color: transparent #f2f2f2;
          }
        }
        .left-item {
          border-start-start-radius: 0;
          .arrow {
            position: absolute;
            left: 0;
            top: -9px;
            border-width: 10px 0px 0px 10px;
          }
        }
        .right-item {
          border-start-end-radius: 0;
          .arrow {
            position: absolute;
            right: 0;
            top: -9px;
          }
        }
      }
    }
    .vue-slider-piecewise-item:first-child, .vue-slider-piecewise-item:last-child {
      .vue-slider-piecewise-dot {
        visibility: visible;
      }
    }
    .vue-slider-piecewise-item:first-child {
      margin-left: 9px;
    }
    .slider-4-100-wrap {
      .vue-slider-piecewise-item:first-child {
        .vue-slider-piecewise-dot {
          visibility: visible;
        }
      }
      .vue-slider:after {
        border-left: 4px solid #ddd;
        top: -12px;
      }
    }
    .slider-init {
      .vue-slider-piecewise-item:first-child {
        display: none;
      }
    }
    .vue-slider-piecewise-item {
      background: #eee;
      width: 1Px !important;
      height: 100% !important;
      position: absolute;
      top: -12px !important;
    }

    .vue-slider-piecewise-item:last-child {
      background: transparent;
    }
    .vue-slider-tooltip {
      min-width: 48px !important;
      line-height: 56px;
      padding: 0 4px !important;
      background: #333 !important;
      border: 1px solid #333 !important;
      position: relative;
      top: -6px;
    }
  }
  .is-matrix {
    margin-top: 0;
    .ivu-form-item-error-tip {
      position: relative;
      top: -15px;
    }
  }
}
.answer-pc {
  .rate-wrapper {
    margin: 0px 0 30px 0;
    width: 70%;
    .slide-star {
      margin-top: 10px;
      .van-rate {
        justify-content: flex-start;
        .van-rate__item {
          margin-right: 4px;
          .van-icon {
            font-size: 25px;
          }
        }
      }
    }
    .rate-3, .rate-4, .rate-6 {
      margin-top: 35px;
      .ivu-form-item-error-tip {
        top: -30px;
      }
    }
    .rate {
      &.rate-2 {
        .ivu-form-item {
          margin-bottom: 10px;
        }
      }
      .vue-slider-piecewise-item {
        top: -6px !important;
      }
      .vue-slider-tooltip {
        min-width: 24px !important;
        line-height: 28px;
        top: -3px;
      }
      .vue-slider-piecewise-item:first-child {
        margin-left: 3px;
      }
      .slider-4-100-wrap {
        .vue-slider:after {
          border-left: 2px solid #ddd;
          top: -6px;
        }
      }
      .slider-init {
        .vue-slider-piecewise-item:first-child {
          display: none;
        }
      }
      .slider-wrap {
        .bottom {
          padding: 0 8px;
          margin-top: 10px;
          .item {
            border-radius: 4px;
            padding: 0 10px;
            font-size: 12px;
            line-height: 24px;
            .arrow {
              border-width: 5px 5px 0px 0px;
            }
          }
          .left-item {
            border-start-start-radius: 0;
            .arrow {
              top: -4px;
              border-width: 5px 0px 0px 5px;
            }
          }
          .right-item {
            border-start-end-radius: 0;
            .arrow {
              top: -4px;
            }
          }
        }
      }
    }
    .is-matrix {
      margin-top: 0;
      .ivu-form-item-error-tip {
        top: -8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/RateGroupBox/RateGroupAnswer.vue